import { Container } from "@mui/material";
import { PowerBIFrame } from "../componente/PowerBIFrame";


export const ColaboracionesExternas: React.FC = () => {
    const anio = new Date().getFullYear();


    return(
        <Container>
            <h1>Colaboraciones Externas</h1>
            <h2>Periodo: {anio - 6} - {anio}</h2>
            <PowerBIFrame embedUrl="https://app.powerbi.com/view?r=eyJrIjoiNDg0MTc0OGItZjg2Ny00YmY2LTgzMTUtMjA5MzM4MGIzMzEyIiwidCI6ImI3YWY4Y2FmLTgzZDgtNDY0NC04NWFlLTMxN2M1NDUyMjNjMSIsImMiOjR9" />

        </Container >
    )
};
